var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var NotificationController = {
    /*****************************************************************************************************
        * Is using route "api/notification" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<NotificationDownloadDto, string>}
    ******************************************************************************************************/
    Get: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/notification", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/notification/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {UserCommentsDownloadDto}
    ******************************************************************************************************/
    Delete: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/notification/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/notification/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {NotificationDownloadDto[]}
    ******************************************************************************************************/
    Update: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/notification/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/notification/send/{templateId}" and http method "POST" to call the back-end.
    
        * @param {string} templateId
        * @param {SendNotificationConfig} config
        * @returns {NotificationDownloadDto[]}
    ******************************************************************************************************/
    SendNotification: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("config", JSON.stringify(data.config));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/notification/send/{templateId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=NotificationController.js.map